import type { useUserJourney } from '~/hooks/interaction/form/useUserJourney';
import type { AnswerUserType } from '~/model/AnswerUserType';
import type { ConclusionType } from '~/model/ConclusionType';
import type { QuestionReconstructedType } from '~/model/QuestionType';
import { apiTypes } from '~/const/api';
import { ElementType } from '~/const/appConst';

export const contributionHasToBeSubmitted = (
  answerUser: AnswerUserType,
  conclusion: ConclusionType,
  currentStepIndex: number,
  isLastStep: boolean,
  nextIndex: number,
  question: QuestionReconstructedType,
  nextStep: ReturnType<typeof useUserJourney>['currentStep'],
): boolean => {
  const answer = answerUser?.[question?.['@id']];
  const answerChoices = (answer?.answer_choices as string[]) || [];
  const answerTypeIsConclusion = answer?.type === apiTypes.CONDITIONAL;
  const nextStepIsConclusion = nextStep?.['@type'] === ElementType.CONCLUSION;

  const conditionalAnswerIsConclusion
    = answerTypeIsConclusion
      && answerChoices.some(
        choice =>
          choice === conclusion?.branch_choice
          && question.choices.some(
            questionChoice =>
              choice === questionChoice?.['@id']
              && !questionChoice.branch_questions.length,
          ),
      );

  const conditionalAnswerNextStepIsNull
    = nextStepIsConclusion
      && answerTypeIsConclusion
      && !question?.next_step?.[answerChoices[0]];

  const isNextIndex = nextIndex > currentStepIndex;
  const lastStepBeforeSubmit
    = isLastStep
      || conditionalAnswerIsConclusion
      || conditionalAnswerNextStepIsNull;

  return isNextIndex && lastStepBeforeSubmit;
};
